
      import API from "!../../../../node_modules/.pnpm/style-loader@3.3.4_webpack@5.109.2/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../node_modules/.pnpm/style-loader@3.3.4_webpack@5.109.2/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../../node_modules/.pnpm/style-loader@3.3.4_webpack@5.109.2/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../../node_modules/.pnpm/style-loader@3.3.4_webpack@5.109.2/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../../node_modules/.pnpm/style-loader@3.3.4_webpack@5.109.2/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../../node_modules/.pnpm/style-loader@3.3.4_webpack@5.109.2/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.109.2/node_modules/css-loader/dist/cjs.js!../../../../node_modules/.pnpm/less-loader@11.1.4_less@4.3.0_webpack@5.109.2/node_modules/less-loader/dist/cjs.js!./fonts.less";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.109.2/node_modules/css-loader/dist/cjs.js!../../../../node_modules/.pnpm/less-loader@11.1.4_less@4.3.0_webpack@5.109.2/node_modules/less-loader/dist/cjs.js!./fonts.less";
       export default content && content.locals ? content.locals : undefined;
